import React from 'react';

import FileDownload from '../../shared/assets/svg/download.svg';

/**
 * CSV download control shown in Accounts Reports tab row (registered via toolbar context).
 */
export function AccountsReportCsvDownloadButton({ onClick, disabled, statusText }) {
  return (
    <button
      type="button"
      className={`relative flex items-center justify-center ${
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
      }`}
      onClick={onClick}
      disabled={disabled}
      aria-label="Download CSV">
      <img height={35} width={35} src={FileDownload} alt="" />
      {statusText ? (
        <span className="absolute top-10 right-0 text-sm text-gray-700 whitespace-nowrap z-10">
          {statusText}
        </span>
      ) : null}
    </button>
  );
}
